import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';

import { SERVICE_RESPONSE_STATUS } from 'constants/common';


/*************************************************************/

/**
 * @type {class}
 * @desc EpostAllergiesAndHealthConditions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { EpostAllergiesAndHealthConditionsService } from 'services/epostAllergiesAndHealthConditions';
 *
 * // create service instance and send/cancel request
 * const epostAllergiesAndHealthConditionsService = new EpostAllergiesAndHealthConditionsService();
 * const result = await epostAllergiesAndHealthConditionsService.fetchData( '<user-id>' ); // fetch data
 * epostAllergiesAndHealthConditionsService.cancel(); // cancel an active request
 */
export class EpostAllergiesAndHealthConditionsService extends HttpService {

     // fetch call control widget data
     async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
            const visibility = get( response, 'body.component.visibility', {} );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data.state' ),
                    options: get( response, 'body.component.data.options' ),
                    ...get( response, 'body.component.structure' ),
                   visibility
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // submit current step data
    async submitStepData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {} )
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
